import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './form-container.component.scss';
import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
import 'multiple-select/dist/multiple-select.min.css';
var FormContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FormContainer, _super);
    function FormContainer(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    FormContainer.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-apply-now-modal-open'));
        this.closeButton = Array.from(this.element.querySelectorAll('.js-apply-now-modal-close'));
        this.pagerPages = Array.from(this.element.querySelectorAll('.js-pager-page'));
        this._currencyFields = Array.from(this.element.querySelectorAll('.form__input--currency'));
        this.publicHolidays = ['2020/12/16', '2020/12/25', '2020/12/26', '2021/01/01', '2021/03/22', '2021/04/02', '2021/04/05', '2021/04/27', '2021/05/01', '2021/06/16', '2021/08/09', '2021/09/24', '2021/12/16', '2021/12/25', '2021/12/26', '2021/12/27'];
        this.npsCustomerSurveyButton = document.querySelector('#nps-customer-survey_button');
        this.npsCustomerSurvey = document.querySelector('#form-container-modal-nps-customer-survey');
        // DATE PICKER
        $(document).ready(function () {
            if ($('.jquery_multipleSelect').length) {
                $('.jquery_multipleSelect').multipleSelect('destroy');
                $('.jquery_multipleSelect').multipleSelect({ placeholder: 'Please select', selectAll: false });
            }
            if ($('.paia-multi-select').length) {
                $('.paia-multi-select').multipleSelect({ placeholder: 'Please select', selectAll: false });
            }
            ///////////////////////////////
            // current date picker
            ///////////////////////////////
            if ($('input.js-date-picker')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true
                };
                instantiateDate('.js-date-picker', datePickerConfig);
            }
            if ($('input.js-date-picker-full')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true
                };
                instantiateDate('.js-date-picker-full', datePickerConfig);
            }
            ///////////////////////////////
            // today disabled date picker + enabling all selection time dropdown
            ///////////////////////////////
            if ($('input.js-date-picker-today-disabled')) {
                var datePickerConfig = {
                    todayHighlight: false,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true
                };
                instantiateDate('.js-date-picker-today-disabled', datePickerConfig);
            }
            if ($('input.js-date-picker-full-today-disabled')) {
                var datePickerConfig = {
                    todayHighlight: false,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true
                };
                instantiateDate('.js-date-picker-full-today-disabled', datePickerConfig);
            }
            if ($('input.js-date-picker-enable-previous-days')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-enable-previous-days', datePickerConfig);
            }
            if ($('input.js-date-picker-enable-previous-days')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-enable-previous-days', datePickerConfig);
            }
            ///////////////////////////////
            // initiate date change function
            ///////////////////////////////
            function instantiateDate(pSelector, pConfig) {
                $('input' + pSelector).datepicker(pConfig).on('changeDate', function (event) {
                    var _event;
                    if (typeof window.event === 'function') {
                        _event = new Event('change');
                        this.dispatchEvent(_event);
                    }
                    else {
                        _event = document.createEvent('HTMLEvents');
                        _event.initEvent('change', false, false);
                        this.dispatchEvent(_event);
                    }
                });
            }
        });
        TooltipsService.initTooltips();
        this.surveyInfoService.checkEnableSurvey();
    };
    FormContainer.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        if (this.closeButton) {
            this.closeButton.map(function (pElement) {
                pElement.addEventListener('click', function (event) { return _this.closeModal(); });
            });
        }
        // this.modalLinks.map((item) => item.addEventListener('click', (event) => {
        // 	this.openModals(event);
        // }));
        // Changed the way this works for dynamic content - Malcolm 14-02-2018
        document.addEventListener('click', function (e) {
            var composedPath = function (el) {
                var path = [];
                while (el) {
                    path.push(el);
                    if (el.tagName === 'HTML') {
                        path.push(document);
                        path.push(window);
                        return path;
                    }
                    el = el.parentElement;
                }
            };
            var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
            var hasClass = function (cls) {
                return _.filter(path, function (p) {
                    var exists = false;
                    _.each(p.classList, function (cl) {
                        if (cl === cls) {
                            exists = true;
                        }
                    });
                    if (p.classList && exists) {
                        return p;
                    }
                })[0];
            };
            if (hasClass('js-apply-now-modal-open')) {
                _this.openModals(e);
            }
        }, false);
    };
    FormContainer.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    FormContainer.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-apply-now-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    FormContainer.prototype.closeModal = function () {
        var _this = this;
        if (this.activeModal) {
            this.analyticsService.dtmFormAbandon();
            this.activeModal.classList.add('modal--close');
            setTimeout(function () {
                _this.activeModal.classList.add('modal--closed');
                if (_this.npsCustomerSurveyButton && _this.npsCustomerSurvey) {
                    _this.surveyInfoService.checkEnableSurvey();
                    if (_this.surveyInfoService.getSurveyCompleteValue() === "false"
                        && (_this.surveyInfoService.getSurveyTimeExpireValue() === ""
                            || _this.surveyInfoService.getSurveyTimeExpireValue() == null)) {
                        if (_this.activeModal != _this.getModalById('form-container-modal-nps-customer-survey')) {
                            _this.npsCustomerSurveyButton.click();
                        }
                        else {
                            // Add expiry time
                            localStorage.setItem(_this.surveyInfoService.getSurveyCompleteName(), "true");
                            _this.surveyInfoService.setTimeExpired();
                            // Hide survey button if any
                            // this.surveyInfoService.hidePageSurveyButton();
                        }
                    }
                }
            }, 250);
        }
    };
    FormContainer.prototype.openModal = function () {
        var _this = this;
        if (this.activeModal) {
            // current date picker
            this.formDatePickerFull = this.activeModal.querySelector('.js-date-picker-full');
            this.formDatePicker = this.activeModal.querySelector('.js-date-picker');
            this.formTimePicker = this.activeModal.querySelector('.js-time-picker');
            if (this.formDatePicker) {
                this.formDatePicker.addEventListener('change', function (event) {
                    _this.validateDate(event.target);
                });
                if (this.formTimePicker) {
                    this.formDatePicker.classList.remove("form__input--required");
                    this.formTimePicker.addEventListener('change', function (event) {
                        if (event.currentTarget.value == "Anytime") {
                            _this.formDatePicker.classList.remove("form__input--required");
                        }
                        else {
                            _this.formDatePicker.classList.add("form__input--required");
                        }
                    });
                }
            }
            // today disabled date picker
            this.formDatePickerFullTodayDisabled = this.activeModal.querySelector('.js-date-picker-full-today-disabled');
            this.formDatePickerTodayDisabled = this.activeModal.querySelector('.js-date-picker-today-disabled');
            this.resetForm();
            this.populateDatePicker();
            this.populateDatePickerTodayDisabled();
            this.activeModal.classList.remove('modal--close');
            this.activeModal.classList.remove('modal--closed');
        }
    };
    FormContainer.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    FormContainer.prototype.togglePages = function (event) {
        this.pagerHomePage.classList.add('apply-now__page--hidden');
        this.pagerHomeButtonContainer.classList.add('apply-now__home-button-container--visible');
        this.hidePages();
        var goToPage = event.currentTarget.getAttribute('data-target');
        this.element.querySelector("#" + goToPage).classList.remove('apply-now__page--hidden');
    };
    FormContainer.prototype.hidePages = function () {
        for (var i = 0; i < this.pagerPages.length; i++) {
            this.pagerPages[i].classList.add('apply-now__page--hidden');
        }
    };
    FormContainer.prototype.showHomePage = function () {
        this.hidePages();
        this.pagerHomePage.classList.remove('apply-now__page--hidden');
        this.pagerHomeButtonContainer.classList.remove('apply-now__home-button-container--visible');
    };
    FormContainer.prototype.resetForm = function () {
        if (this.form) {
            var _errorFields = Array.from(this.form.querySelectorAll(".form__group--error"));
            if (_errorFields.length > 0) {
                _errorFields.forEach(function (element) {
                    element.classList.remove("form__group--error");
                });
            }
            var _errorMessages = Array.from(this.form.querySelectorAll(".form__group--error_message"));
            if (_errorMessages.length > 0) {
                _errorMessages.forEach(function (element) {
                    element.remove();
                });
            }
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            if (formContainerLoader) {
                formContainerLoader.classList.remove('active');
            }
            if (formContainerFields) {
                formContainerFields.classList.remove('hidden');
            }
            if (formContainerThankyou) {
                formContainerThankyou.classList.remove('active');
            }
            if ($('.paia-multi-select').length) {
                $('.paia-multi-select:selected').prop("selected", false);
                $('.paia-multi-select').multipleSelect("refresh");
            }
            if ($('.jquery_multipleSelect').length) {
                $('.jquery_multipleSelect:selected').prop("selected", false);
                $('.jquery_multipleSelect').multipleSelect("refresh");
            }
            // allow individual form items components to handle form reset
            var event_1 = new CustomEvent('custom_form_reset_event');
            this.form.dispatchEvent(event_1);
        }
    };
    // populating the current date picker
    FormContainer.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
        }
        if (this.formDatePickerFull) {
            this._startDate = this.validateDate();
            $(this.formDatePickerFull).datepicker('setStartDate', this._startDate);
        }
    };
    // populating the today disabled date picker
    FormContainer.prototype.populateDatePickerTodayDisabled = function () {
        if (this.formDatePickerTodayDisabled) {
            this._startDate = this.validateDateTodayDisabled();
            $(this.formDatePickerTodayDisabled).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
        }
        if (this.formDatePickerFullTodayDisabled) {
            this._startDate = this.validateDateTodayDisabled();
            $(this.formDatePickerFullTodayDisabled).datepicker('setStartDate', this._startDate);
        }
    };
    // validate current date picker functionality
    FormContainer.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate != '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate != _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore == 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore == 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate == holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay == 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay == 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter == 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter == 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        if (this.formTimePicker) {
            var item = this.formTimePicker;
            var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
            for (var i = item.options.length - 1; i >= 0; i--) {
                if (item.options[i].value != 'Anytime') {
                    if ((item.options[i].value < _tmpTime) && (_enabledOptions == false)) {
                        item.options[i].disabled = true;
                    }
                    else if (_enabledOptions == true) {
                        item.options[i].disabled = false;
                    }
                }
            }
        }
        return _currentDateTime;
    };
    // validate today disabled datepicker functionality
    FormContainer.prototype.validateDateTodayDisabled = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        if (_setDate != '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate != _tmpCurrentDate) {
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        var _currentDayBefore = _currentDateTime.getDay();
        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        if (_currentDayBefore == 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore == 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate == holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay == 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay == 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter == 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter == 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        return _currentDateTime;
    };
    return FormContainer;
}(Base));
export { FormContainer };



//////////////////
// WEBPACK FOOTER
// ./components/form-container/form-container.component.ts
// module id = 313
// module chunks = 0